module.exports = __webpack_public_path__ + "img/phone.b77662fa.svg";